import React, { useState, useEffect } from 'react'
import { Row, Col, Button } from 'react-bootstrap';
import {  useSelector } from 'react-redux'
import { useNavigate, useParams } from 'react-router-dom';
import { LinkContainer } from 'react-router-bootstrap';
import { useStudentSubjectsQuery } from '../../slices/students/studentsApiSlice';
import StudentHeader from '../../components/StudentHeader';
import StudentNavbar from '../../components/StudentNavbar';
import Loader from '../../components/Loader';
import Message from '../../components/Message';
import Subject from '../../components/Subject';
import StudentAskSubject from '../../components/StudentAskSubject';
import NoSubject from '../../components/NoSubject';
import PaginateNewAnswers from '../../components/PaginateNewAnswers';
import { colors43 } from '../../colorConstant';


const StudentsAskNew = () => {

    const { pageNumber } = useParams();
    const navigate = useNavigate();

    const colors2 = [];

    const { studentInfo } = useSelector((state) => state.authStudent);

    const { data, isLoading, error } = useStudentSubjectsQuery({pageNumber});

    for (let i = 0; i < data?.subjects?.length; i++) {
        colors2.push(colors43[i]);
    }

    useEffect(() => {
        if(!studentInfo) {
            navigate('/studentlogin')
        }
    }, [navigate, studentInfo])

  return (
    <div>
        <StudentNavbar />
        <div className="main-content" id="panel">
            <StudentHeader /><br /><br /><br /><br />
            <div className="container-fluid mt--6">
                {isLoading ? ( 
                    <Loader />
                ) : error ? (
                    <Message variant='danger'>
                        {error?.data?.message || error.error}
                    </Message>
                ) : (
                    <div className="row">
                        <h3 className="centerTitle tittleColor4 ">
                                <span className='tittleColor4'>
                                    Ask a new question
                                </span>
                        </h3><br /><br />
                        {data?.subjects.map((subject, index) => (
                            <div key={subject._id} className="col-md-6 col-xl-4">
                                <StudentAskSubject subject={subject} color={colors2[index]} />
                            </div>
                        ))}
                        {data?.subjects.length == 0 && 
                        <div className="col-md-6 col-xl-4 ">
                            <NoSubject />
                        </div>
                        }
                         <PaginateNewAnswers
                            pages={data?.pages}
                            page={data?.page}
                            link={`studentasknew`}
                            className='pagCenterStudent'                                                
                        />
                    </div>
                )} 
            </div>
        </div>
    </div>
  )
}

export default StudentsAskNew
